import { Quote } from "lucide-react";
import { Reveal } from "./Reveal";
import { useI18n } from "../i18n/LanguageContext";

export const PresidentWord = () => {
  const { t } = useI18n();
  return (
    <section data-testid="president-section" className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
      <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-center">
        <Reveal className="md:col-span-3">
          <div className="relative w-40 md:w-full max-w-[220px]">
            <div className="absolute -top-3 -left-3 w-full h-full border border-wood-dark/40" aria-hidden />
            <img
              src="/images/president.jpg"
              alt="Jean-Philippe Vacher, Président de la SAS Vaucopin"
              loading="lazy"
              className="relative w-full aspect-square object-cover grayscale-[15%]"
            />
          </div>
        </Reveal>

        <Reveal delay={0.15} className="md:col-span-8 md:col-start-5">
          <p className="text-xs uppercase tracking-[0.25em] text-pine-light font-semibold mb-8">
            {t("president.overline")}
          </p>
          <blockquote>
            <Quote aria-hidden className="w-10 h-10 text-wood/50 mb-6" />
            <p className="font-serif text-2xl md:text-4xl leading-snug text-pine tracking-tight">
              {t("president.quote")}
            </p>
          </blockquote>
          <div className="mt-10 flex items-center gap-4">
            <span className="w-12 h-px bg-wood-dark" aria-hidden />
            <div>
              <p className="font-semibold text-pine">Jean-Philippe Vacher</p>
              <p className="text-sm text-ink/50">{t("president.role")}</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
